export default [
	{
		path: "/dev",
		component: () => import("../views/Dev/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/dev/geoloc",
		component: () => import("../views/Dev/GeoLoc.vue"),
		meta: {
			hasmainmenu: true
		}
	},
]
